import { Reducer } from "redux";

import { ServiceTypeState } from "./serviceTypeTypes";
import actionTypes from "../../redux/actionTypes";
export const initialState: ServiceTypeState = {
  data: [],
  errors: undefined,
  loading: false,
};

const serviceTypeReducer: Reducer<ServiceTypeState> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_SERVICE_TYPE_SUCCESS: {
      return { ...state, loading: false, data: action.payload };
    }
    case actionTypes.LOAD_SERVICE_TYPE_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default serviceTypeReducer;
